import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import { RootState } from "../../../../redux/store";
import { commonAction } from "../../../../redux/features/commonSlice";
import CloseIcon from "../../../../components/icons/CloseIcon";
import { CommonEnums } from "../../../../enums/common.enums";
import { clientRoutes } from "../../../../utils/routes";

import FilterDates from "../../filter/FilterDates";
import SearchFilterSelector from "../../filter/SearchFilterSelector";
import FixDataFilterSelector from "../../filter/FixDataFilterSelector";
import "./BrandFontsFilter.scss";

const BrandFontsFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const homePageFilter = useSelector(
    (state: RootState) => state?.common?.homePageFilter,
  );
  const resetFilter = useSelector(
    (state: RootState) => state?.common?.resetFilter,
  );

  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const onSubmitHandler = (values: any) => {
    console.log("🔵 Filter values:", values);

    const navigationString =
      `brand-fonts?brand_id=${values?.brand_id || ""}` +
      `&brand_name=${values?.brand_name || ""}` +
      `&status=${values?.font_status || ""}` +
      `&start_date=${
        values?.startDate === "00-00-00" ? "" : values?.startDate
      }` +
      `&end_date=${values?.endDate === "00-00-00" ? "" : values?.endDate}`;

    navigate(`/${navigationString}`);
    dispatch(commonAction.resetFilter());
    onCloseFilter();
  };

  const initialValues: any = {
    brand_id: "",
    brand_name: "",
    status: "",
    font_status: "",
    startDate: "",
    endDate: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      brand_id: Yup.string().optional(),
      brand_name: Yup.string().optional(),
      status: Yup.string().optional(),
      font_status: Yup.string().optional(),
      startDate: Yup.string().optional(),
      endDate: Yup.string().optional(),
    }),
    onSubmit: onSubmitHandler,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
  });

  const onClickClear = () => {
    formik.setValues({
      brand_id: "",
      brand_name: "",
      status: "",
      font_status: "",
      startDate: "00-00-00",
      endDate: "00-00-00",
    });

    navigate(clientRoutes.brandFonts);
    onCloseFilter();
    dispatch(commonAction.resetFilter());
  };

  useEffect(() => {
    const brand_id = searchParams.get("brand_id") || "";
    const brand_name = searchParams.get("brand_name") || "";
    const status = searchParams.get("status") || "";
    const start_date = searchParams.get("start_date") || "";
    const end_date = searchParams.get("end_date") || "";

    formik.setValues({
      brand_id,
      brand_name,
      status,
      font_status: status,
      startDate: start_date,
      endDate: end_date,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetFilter, searchParams.toString()]);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`invites-filter-container ${
          homePageFilter ? "" : "deactivate-filter"
        }`}
      >
        {homePageFilter && (
          <div className="filter-background" onClick={onCloseFilter}></div>
        )}

        <div
          className={`invites-filter-box ${
            homePageFilter ? "" : "deactivate-filter"
          }`}
        >
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>
            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>

          <div className="filter-body-container">
            <div className="filter-selector-container">
              <SearchFilterSelector
                formik={formik}
                lable="Brand"
                formik_key_id="brand_id"
                formik_key_name="brand_name"
              />

              <div style={{ marginTop: 24 }}>
                <FixDataFilterSelector
                  formik={formik}
                  type={CommonEnums.selectorType?.font_status}
                  placeholder="Status"
                />
              </div>

              <FilterDates formik={formik} lable="Created date" />
            </div>
          </div>

          <div className="action-btn">
            <button
              type="button"
              className="clear-filters-btn"
              onClick={onClickClear}
            >
              Clear Filters
            </button>

            <button type="submit" className="apply-btn">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default BrandFontsFilter;
